module.exports = __webpack_public_path__ + "img/informacion.05fafe2f.svg";